/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import listAllSaga from './listAll';
import byIdSaga from './byId';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { CategoryAndSubCategory, CategoryShort } from '../../hooks/api/categories';
import { PaginatedResponse } from '../types';

export const moduleName = 'category';

export interface State {
  list: BaseState<PaginatedResponse<CategoryShort>>,
  listAll: BaseState<PaginatedResponse<CategoryAndSubCategory>>,
  byId: BaseState<CategoryAndSubCategory>,
  create: BaseState,
  update: BaseState,
  delete: BaseState
}

const models = ['list', 'listAll', 'byId', 'create', 'update', 'delete'];

export const defaultState: State = createCRUDStates<State>(models);

export const category = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = category;

export function useCategory(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* listAllSaga();
  yield* byIdSaga();
}
